import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnDestroy } from '@angular/core';
import { DataInput }  from '@trivelope/triv-ui-tools-lib';
import { debounceTime, map, Subscription } from 'rxjs';
import { NewsService } from 'src/app/services/news.service';
import { Rubric } from 'src/app/classes/news';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UntypedFormGroup } from '@angular/forms';



@Component({
	selector: 'app-rubric-editor',
	templateUrl: './rubric-editor.component.html',
	styleUrls: [ './editor.component.css' ]
})
export class RubricEditorComponent implements OnInit, AfterViewInit, OnDestroy {


	private _group = new Rubric();
	@Input() set group( val: Rubric ) {
		this._group = val;
		this.updateValueForm();
	}
	get group() { return this._group; }

	formG1 = new UntypedFormGroup( {} );
	myInputs: { [key: string]: DataInput } = {};

	@Output() done = new EventEmitter<Rubric>();
	@Output() deleted = new EventEmitter<Rubric>();


	bSaving = false;
	subscriptions = new Subscription();
	bIsDuplicate = false;


	constructor(
		private newsService: NewsService,
		private matSnackBar: MatSnackBar
	) {}


	ngOnInit() {

		const di1 = new DataInput();
		di1.id = "name";
		di1.label = "Name";
		di1.type = "text";
		di1.required = true;
		di1.maxlength = 50;
		this.myInputs[ "name" ] = di1;

		const di2 = new DataInput();
		di2.id = "active";
		di2.label = "Aktiviert";
		di2.type = "check";
		this.myInputs[ "active" ] = di2;

		const di3 = new DataInput();
		di3.id = "userSubscribable";
		di3.label = "vom Benutzer abonnierbar";
		di3.type = "check";
		this.myInputs[ "userSubscribable" ] = di3;

	}


	ngAfterViewInit() {

		setTimeout( () => {

			this.updateValueForm();

			this.subscriptions.add(
				this.formG1.valueChanges.pipe(
					debounceTime( 400 ),
					map( values => {

						if( !this.formG1.valid ) return;
						if( !this._group.id ) return;
						const newName = "" + this.formG1.get( "name" )?.value;
						this.bIsDuplicate = !this.newsService.isUniqueCalendarName( this._group.id, newName );
						if( this.bIsDuplicate ) return;

						this.save();

					})
				).subscribe()
			);

		}, 1 );

	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}


	updateValueForm() {

		// console.log( "this.formG1", this.formG1, this.formG1.controls )
		// console.log( "this.formG1.get( 'name' )", this.formG1.get( 'name' ) )
		if( this.formG1.get( 'name' ) ) {	// the formgroup is already initialized
			this.formG1.reset();
			this.formG1.patchValue( {
				name: this._group.name,
				active: this._group.active,
				userSubscribable: this._group.userSubscribable
			} );
		}
	}

	cancel() {
		this.done.emit( new Rubric() );
	}

	reset() {
		this.updateValueForm();
	}

	save() {

		const elementToSave = { ...this._group } as Rubric;

		elementToSave.name = this.formG1.get( "name" )?.value || "";
		elementToSave.active = this.formG1.get( "active" )?.value || false;
		elementToSave.userSubscribable = this.formG1.get( "userSubscribable" )?.value || false;

		this.bSaving = true;

		this.newsService.saveRubric( elementToSave ).subscribe( savedRubric => {

			this.bSaving = false;

			if( savedRubric && savedRubric.id ) {
				this.matSnackBar.open( 'Erfolgreiche Speicherung', 'Speichern' );
				this._group.active = savedRubric.active;
				this._group.name = savedRubric.name;
				this._group.id = savedRubric.id;
				this._group.userSubscribable = savedRubric.userSubscribable;
				this.formG1.markAsPristine();
			}
			this.done.emit();

		});

	}


	/*
	delete() {

		this.matDialog.open(
			ConfirmationDialogComponent,
			{ data: "Möchten Sie die Rubrik '" + this._group.name + "' wirklich löschen?" }
		)
		.afterClosed().subscribe( result => {

			if( !result ) return;

			this.newsService.deleteRubric( this._group.id ).subscribe( b => {

				if( b ) this.deleted.emit();

			});

		});

	}
	*/


}
